// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".inputCe .datatable-body-cell {\n  padding: 0 !important;\n}\n\n.datatable-body-cell.checkbox-ce .datatable-body-cell-label {\n  overflow: initial;\n}\n\n.classTest {\n  border: solid 2px orange !important;\n  border-bottom: 0 !important;\n  box-shadow: inset 0px -3px 0 0 orange !important;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
